module.exports = __webpack_public_path__ + "static/media/i1.28c523e2.jpg";